import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box, Typography, Card, CardContent, Grid, Avatar, CardMedia, CardActions, IconButton, Skeleton,
  Tooltip,
  TablePagination
} from "@mui/material";
import { useHistory, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import ReusableButton from "../../components/reusableComponents/reusableButtonComponents";
import ReusableHeadingComponents from "../../components/reusableComponents/reusableHeadingComponents";
import ReusableMuiIcons from "../../_helpers/ReusableMuiIcons";
import SearchInput from "../../components/reusableComponents/reusableSearchInput";
import Tablecomponent from "../../components/reusableComponents/Tablecomponent";
import ReusableChip from "../../components/reusableComponents/chipSelector";
import GenerateColumns from "../../_helpers/reusablefunctions/GenerateColumns";
import ApiService from "../../_services/ApiService";

import Icon1 from '../../img-offer/Icon1.svg';
import Icon2 from '../../img-offer/Icon2.svg';
import { CardMediaSkeleton, CardSkeleton, CardSkeletonCount, CompactCardSkeleton } from "../../components/reusableComponents/SkeletonCard";
import NoOfferYetCreated from "./noOfferYetCreated";
import useDebounce from "../../_helpers/reusablefunctions/useDebounce";
import { getCampaignStatus, getCampaignStatusColor } from "../../_helpers/reusablefunctions/campaignStatus";

const OffersManagement = () => {

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 1000);
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [mode, setMode] = useState("view");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offerDetails, setOfferDetails] = useState([]);
  const [cardStats, setCardStats] = useState();
  const [loading, setLoading] = useState(true);
  const { stepName } = useParams();
  const location = useLocation();
  const [hasDrafts, setHasDrafts] = useState(false);
  const [count, setCount] = useState(0);

  const history = useHistory();

  const handleCreateOffer = () => history.push("/new-offer/campaign-type");
  const handleViewOffer = (id) => history.push(`/view-offer/${id}/overview`);
  const handleEditOffer = (id) => {
    history.push(`/edit-offer/overview/${id}`);
  };
  const handleDraft = () => {
    history.push("/view-offer-drafts")
  }
  const isSidebarOpen = useSelector((state) => state.sidebar?.open ?? false);

  const columnConfig = [
    // {
    //   field: "banner",
    //   headerName: "Brand",
    //   type: "custom",
    //   renderComponent: ({ value, row }) => (
    //     <Box display="flex" alignItems="center" gap={1}>
    //       <Avatar src={value} alt={row.title}>{row.title?.[0]}</Avatar>
    //     </Box>
    //   )
    // },
    // { field: "title", headerName: "Campaign Title", type: "custom", sortable: true },
    {
      field: "title",
      headerName: "Campaign Title",
      type: "custom",
      sortable: true,
      renderComponent: ({ value, row }) => (
        <Box display="flex" alignItems="center" gap={1}>
          <Avatar src={row.banner} alt={value}>
            {value?.[0]}
          </Avatar>
          <span>{value}</span>
        </Box>
      )
    },
    {
      field: 'campaign_type', headerName: "Campaign Type", type: "custom",
      renderComponent: ({ value, row }) => <ReusableChip label={row?.campaign_type?.campaign_name} />
    },
    {
      field: 'brand_name', headerName: "Campaign Manager", type: "text",
      renderComponent: ({ value, row }) => <ReusableChip label={row?.brand_name} />
    },
    {
      field: "effective_status",
      headerName: "Status",
      type: "custom",
      sortable: true,
      renderComponent: ({ row }) => {
        const status = getCampaignStatus(row);
        return (
          <ReusableChip
            label={status}
            bgcolor={getCampaignStatusColor(status).bgcolor}
            color={getCampaignStatusColor(status).color}
          />
        );
      }
    },
    { field: "start_date", headerName: "Start Date", type: "text" },
    { field: "end_date", headerName: "End Date", type: "text" },
    {
      field: "action", headerName: "", type: "custom", minWidth: 100,
      renderComponent: ({ value, row }) => (
        <ReusableButton variant="contained" classNames="gn-actionbtn" children="View" onClick={() => handleViewOffer(row.id)} />
      )
    }
  ];
  const columns = GenerateColumns(columnConfig);
  const color = '#000'
  const stats = [
    { label: "Total Active Offers", value: cardStats?.active || '0', icon: <ReusableMuiIcons name={'event'} sx={{ color: '#D8A353' }} fontSize="large" /> },
    { label: "Total Upcoming Offers", value: cardStats?.upcoming || '0', icon: <ReusableMuiIcons name={'calender'} sx={{ color: '#4C9AFF' }} fontSize="large" /> },
    { label: "Total Closed Offers", value: cardStats?.closed || '0', icon: <ReusableMuiIcons name={'busyEvent'} sx={{ color: '#D85B53' }} fontSize="large" /> },
    { label: "Total Applications", value: cardStats?.total_applications || "0", icon: <ReusableMuiIcons name={'assignment'} sx={{ color: '#595BD4' }} fontSize="large" /> },
    // { label: "Total Collaboration", value: "0", icon: <ReusableMuiIcons name={'groupUser'} color='primary' fontSize="large" />, subtitle: "Engaged" },
  ];

  const categories = [
    { label: 'All' },
    { label: 'Barter' },
    // { label: 'Discount', count: 3 },
    // { label: 'Experimental / Store Invite', count: 2 },
    // { label: 'Affiliate', count: 1 },
    // { label: 'Brand Ambassador', count: 1 },
    // { label: 'Draft' },
    // { label: 'Review' }
  ];


  useEffect(() => {
    setLoading(true);
    const fetchOffers = async () => {
      const params = {
        limit: rowsPerPage,
        offset: page * rowsPerPage,
      };

      if (selectedCategory === "All") {
        params.is_draft = false;
      } else {
        switch (selectedCategory) {
          case "Barter":
            params.type = "barter";
            params.is_draft = false;
            break;
          // case "Review":
          //   params.is_published = false;
          //   params.is_draft = false;  
          //   break;
          // case "Draft":
          //   params.is_draft = true;
          //   break;
          default:
            params.is_draft = false;
            break;
        }
      }
      if (debouncedSearchTerm) {
        params.search = debouncedSearchTerm;
      }
      try {
        const res = await ApiService.get("all_campaigns", params);
        const allData = res?.data?.results || [];
        setOfferDetails(res?.data?.results || []);
        setCardStats(res?.data?.stats)
        setCount(res?.data?.count)
        setHasDrafts(allData.some(item => item.is_draft));
      } catch (error) {
        console.error("Error fetching offers:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOffers();
  }, [selectedCategory, debouncedSearchTerm, page, rowsPerPage, location.pathname]);

  return (
    <Box p={4}>
      <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
        <ReusableHeadingComponents
          heading="Exclusive Offers Management"
          subHeading="Effortlessly Create, Manage & Track Your Brand Offers."
        />
        <Box>
          <ReusableButton children={'Draft'} startIcon={<ReusableMuiIcons name={"create"} />} variant="outlined" classNames={'gn-actionbtn-outline gn-actionbtn-color me-3'} onClick={handleDraft} />
          <ReusableButton
            children="Create new offer"
            variant="contained"
            classNames="gn-actionbtn"
            onClick={handleCreateOffer}
            startIcon={<ReusableMuiIcons name="add" />}
          />
        </Box>
      </Box>

      <Grid container spacing={2}>
        {loading ? (
          Array.from({ length: 4 }).map((_, i) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
              <CardSkeletonCount />
            </Grid>
          ))
        ) : (
          stats.map((s, i) => (
            <Grid item xs={12} sm={6} md={3} key={i}>
              <Box sx={{ background: "#FFFFFF", borderRadius: 2, padding: "15px 10px" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar sx={{ bgcolor: "#F5F6FF", width: 64, height: 64 }}>{s.icon}</Avatar>
                  <Box>
                    <Typography sx={{ color: "#8C8C8C", fontWeight: 400, fontSize: "14px" }}>
                      {s.label}
                    </Typography>
                    <Typography sx={{ color: "#2B3674", fontWeight: 700, fontSize: "28px" }}>
                      {s.value}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>
          ))
        )}
      </Grid>


      {/* Filter Bar */}
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" my={2}>
        <SearchInput placeholder="Search Offers" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} sx={{ width: "35%" }} />
        <Box>
          {['view', 'viewlist'].map((name) => (
            <IconButton
              key={name}
              onClick={() => setMode(name)}
              sx={{
                backgroundColor: mode === name && '#7A7A7A',
                color: mode === name && '#fff',
                border: "1px solid #e0e0e0", borderRadius: 1
              }}
            >
              <ReusableMuiIcons name={name} />
            </IconButton>
          ))}
        </Box>
      </Box>

      <Card sx={{
        display: "flex", gap: 1, p: 1, overflowX: 'auto',
        '&::-webkit-scrollbar': { height: 6 },
        '&::-webkit-scrollbar-thumb': { bgcolor: '#ccc', borderRadius: 1 },
      }}>
        {categories.map(({ label, count }) => (
          <ReusableChip
            key={label}
            // label={`${label} (${count})`}
            label={`${label}`}
            variant="outlined"
            size="small"
            onClick={() => setSelectedCategory(label)}
            sx={{
              border: 'none',
              color: selectedCategory === label ? '#fff' : '#8C8C8C',
              bgcolor: selectedCategory === label ? '#ED1C24' : 'transparent',
              fontSize: 14, fontWeight: 500, p: 1, height: 35, borderRadius: 2,
              '&:hover': { bgcolor: '#ED1C24 !important', color: '#fff' },
            }}
          />
        ))}
      </Card>

      {mode === "view" ? (
        <>
          <Grid container spacing={2} mt={2}>
            {loading ? (
              Array.from({ length: 8 }).map((_, i) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
                  <CardMediaSkeleton />
                </Grid>
              ))
            ) : offerDetails.length === 0 ? (
              <Grid item xs={12}>
                {/* <Typography textAlign="center" color="text.secondary">No offers found.</Typography> */}
                <NoOfferYetCreated
                  message={
                    searchTerm
                      ? `No offers found for "${searchTerm}"`
                      : "No Offers Yet"
                  }
                  content={
                    searchTerm
                      ? ""
                      : "Start by creating your first campaign — choose from barter, affiliate, store invite, or ambassador types."
                  }
                />
              </Grid>
            ) : (
              offerDetails.map((offer) => (
                <Grid item xs={12} sm={6} md={4}   lg={isSidebarOpen ? 4 : 3} key={offer.id} sx={{ paddingBottom: '20px' }}>
                  <Card sx={{ p: 2, borderRadius: 2, height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <CardMedia component="img" height="160" image={offer.banner} alt={offer.title} sx={{ borderRadius: 1 }} />
                    <CardContent sx={{ px: 0, flexGrow: 1 }}>
                      <Box display="flex" justifyContent="space-between" mb={1}>
                        <ReusableChip label={offer?.campaign_type?.campaign_name} bgcolor="#F4F7FE" color="#454545" borderRadius="16px" />
                        <ReusableChip
                          label={getCampaignStatus(offer)}
                          bgcolor={getCampaignStatusColor(getCampaignStatus(offer)).bgcolor}
                          color={getCampaignStatusColor(getCampaignStatus(offer)).color}
                          borderRadius="16px"
                        />
                      </Box>
                      <Typography variant="subtitle1" fontWeight={700} sx={{ display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden",textOverflow: "ellipsis", lineHeight: 1.3, minHeight: "42px", }}>{offer.title}</Typography>
                      <Box display="flex" gap={1} mt={1}>
                        <img src={Icon1} alt="Start" /><Typography variant="caption">{offer.start_date}</Typography>
                        <img src={Icon2} alt="End" /><Typography variant="caption">{offer.end_date}</Typography>
                      </Box>
                    </CardContent>
                    <CardActions sx={{ px: 0, pb: 0, mt: 'auto', justifyContent: 'center', gap: 1 }}>
                      <Tooltip
                        title={
                          offer?.is_draft === false
                            ? "This offer has been published and can no longer be edited."
                            : ""
                        }
                        arrow>
                        <span style={{ display: "flex", flex: 1 }}>
                          <ReusableButton fullWidth children="Edit" variant="outlined" classNames={offer?.is_draft === false ? "gn-actionbtn-disable" : "gn-actionbtn-outline gn-actionbtn-color"} onClick={() => handleEditOffer(offer.id)} disabled={offer?.is_draft === false} />
                        </span>
                      </Tooltip>
                      <Box sx={{ flex: 1, display: "flex" }}><ReusableButton fullWidth children="View" variant="contained" classNames="gn-actionbtn" onClick={() => handleViewOffer(offer.id)} /></Box>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
          <Box display="flex" justifyContent="flex-end">
            <TablePagination
              component="div"
              count={count}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[10, 20, 30]}
              sx={{
                "& .MuiTablePagination-selectLabel": {
                  paddingTop: '14px'
                },
                "& .MuiTablePagination-select": {
                  display: "inline-flex",
                  alignItems: "center",
                  paddingY: "0px",
                },
                "& .MuiTablePagination-displayedRows": {
                  margin: 0,
                },
              }}
            />
          </Box>
        </>
      ) : (
        <Box mt={2} mb={2}>
          <Tablecomponent
            columns={columns}
            data={offerDetails}
            count={count}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setPage(0);
            }}
            rowsPerPageOptions={[10, 20, 30]}
            message={"No Offers Yet"}
          />
        </Box>
      )}

    </Box>
  )
};

export default OffersManagement;
